import Donation from '../Organism/Sponser/Donation';
import First from '../Organism/Sponser/First';
import Five from '../Organism/Sponser/Five';
import Four from '../Organism/Sponser/Four';
import Last from '../Organism/Sponser/Last';
import RareBlood from '../Organism/Sponser/RareBlood';
import Second from '../Organism/Sponser/Second';
import Seven from '../Organism/Sponser/Seven';
import Six from '../Organism/Sponser/Six';
import ThanksLetters from '../Organism/Sponser/ThanksLetters';
import Third from '../Organism/Sponser/Third';

const SponserTemplate = () => {
  return (
    <>
      <First />
      <Second />
      <Third />
      <Four />
      <Five />
      <Six />
      <ThanksLetters />
      <RareBlood />
      <Donation />
      <Seven />
      <Last />
    </>
  );
};

export default SponserTemplate;
